import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { App } from "./App";
import { createApiClient } from "./api";
import { ApiClientProvider } from "./api/ApiClientContext";
import { AuthProvider } from "./context/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { emotionCache } from "./theme/emotionCache";
import { leeftTheme } from "./theme/leeftTheme";

async function bootstrap() {
  const apiClient = await createApiClient();
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root element #root not found");
  }

  createRoot(container).render(
    <StrictMode>
      <CacheProvider value={emotionCache}>
        <ThemeProvider theme={leeftTheme}>
          <CssBaseline />
          <ApiClientProvider client={apiClient}>
            {/*
              The outermost safety net (manager report): a render crash
              anywhere, including one before routing or auth even resolve,
              still shows a friendly message rather than a blank page. Home
              is "/", the signed-in/signed-out router's own entry point,
              since role is not known this far out.
            */}
            <ErrorBoundary homeTo="/" homeLabel="Back to sign in">
              <BrowserRouter>
                <AuthProvider>
                  <App />
                </AuthProvider>
              </BrowserRouter>
            </ErrorBoundary>
          </ApiClientProvider>
        </ThemeProvider>
      </CacheProvider>
    </StrictMode>,
  );
}

void bootstrap();
